/**
 * AttachmentChip — the shared "angehängt: <filename>" pill (Feature B).
 *
 * Lifted verbatim from BrokComposer's inline chip so the composer (staged, with a
 * remove x) and the transcript (read-only, on the sent user message) render the
 * exact same markup. Pass `onRemove` to show the remove button; omit it for the
 * read-only transcript chip.
 */
import { Paperclip, X } from 'lucide-react';
import { cn } from '../../../lib/cn';

interface Props {
  filename: string;
  /** When provided, shows the remove (x) button (composer). Omit for read-only (transcript). */
  onRemove?: () => void;
  className?: string;
}

export function AttachmentChip({ filename, onRemove, className }: Props) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-md border border-border bg-muted px-2 py-1 text-xs text-foreground',
        className,
      )}
      data-testid="brok-attachment-chip"
    >
      <Paperclip size={12} aria-hidden />
      <span className="max-w-[220px] truncate">angehängt: {filename}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Anhang entfernen"
          className="rounded p-0.5 text-muted-foreground hover:text-foreground"
        >
          <X size={12} />
        </button>
      )}
    </div>
  );
}
